/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'GoalLinker.error.generic.description': 'Проверьте подключение к Интернету и повторите попытку.',
  'GoalLinker.error.generic.header': 'Произошла ошибка',
  'GoalLinker.error.linking.header': 'Не удалось связать цель',
  'GoalLinker.error.max-entities-to-goal.description':
    'С целью можно связать не более 100 элементов ({entities}). Чтобы привязать дополнительные {entities}, удалите один из этих элементов.',
  'GoalLinker.error.max-entities-to-goal.header': 'Достигнут лимит в 100 элементов типа «{entity}»',
  'GoalLinker.error.max-goals.description':
    'Можно связать не более 100 целей. Если вы хотите связать дополнительные цели, удалите некоторые из связанных целей.',
  'GoalLinker.error.max-goals.header': 'Достигнут лимит в 100 целей',
  'GoalLinker.goal-row.open-goal': 'Открыть цель',
  'GoalLinker.link-goals.error-description': 'Произошла ошибка. Проверьте подключение к Интернету и повторите попытку.',
  'GoalLinker.link-goals.error-title': 'Не удалось отвязать цель',
  'GoalLinker.linked-goals.header': 'Связанные цели',
  'GoalLinker.linked-goals.show-less': 'Свернуть',
  'GoalLinker.linked-goals.show-more': 'Показать еще {count}',
  'GoalLinker.recents.emptystate-jira-product-discovery.description':
    'Связывайте идеи с целями, чтобы отслеживать, как работа способствует достижению результатов',
  'GoalLinker.recents.emptystate-project.description':
    'Связывайте проекты с целями, чтобы отслеживать, как работа способствует достижению результатов',
  'GoalLinker.recents.emptystate.description':
    'Связывайте задачи с целями, чтобы отслеживать, как работа способствует достижению результатов',
  'GoalLinker.recents.emptystate.header': 'Начните работу с целями',
  'GoalLinker.recents.header': 'Недавние цели',
  'GoalLinker.search.emptystate.description': 'Попробуйте проверить текст на опечатки',
  'GoalLinker.search.emptystate.header': 'Нет подходящих результатов',
  'GoalLinker.search.label': 'Результаты',
  'GoalLinker.search.placeholder': 'Найдите цели или вставьте ссылку',
};
